// src/pages/BinScreen.jsx
import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import BinInstruction from "../components/BinInstruction/BinInstruction";

export default function BinScreen() {
  const { hallName } = useParams();
  const navigate = useNavigate();
  const decodedName = decodeURIComponent(hallName);

  // Replace this with your real bin mapping logic (eventually from Firebase)
  const binMap = {
    "Qdoba": { binNumber: 2, binType: "compost" },
    "Atomic Pizzeria": { binNumber: 1, binType: "trash" },
    "Origami - Sushi": { binNumber: 2, binType: "compost" },
    "Origami - Teppanyaki": { binNumber: 2, binType: "compost" },
    "Jamba - Smoothies": { binNumber: 1, binType: "trash" },
    "Soup Garden": { binNumber: 3, binType: "recycle" },
    "Dolci - Drinks": { binNumber: 3, binType: "recycle" },
    "1872 - Grill": { binNumber: 1, binType: "trash" },
  };

  const { binNumber, binType } = binMap[decodedName] || {
    binNumber: "?", binType: "trash"
  };

  return (
    <BinInstruction
      binNumber={binNumber}
      binType={binType}
      onBack={() => navigate("/")}
    />
  );
}
